export default __webpack_public_path__ + "static/media/classic-map.736ee3d2.png";